export const getUTMParams = () => {
  let conversionData = {};
  let campaign = {
    url: location.href,
  };

  // oxlint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (window.evGTMTracking) {
    const evGTMConversionData = window.evGTMTracking.getConversionData?.();

    conversionData = {
      referrer: evGTMConversionData?.referrer,
      landingPageOwnerShopID: evGTMConversionData?.landingPageOwnerShopId,
      landingPageURLWithUTM: evGTMConversionData?.landingPageUrlWithUtm,
      snowplowSessionID: evGTMConversionData?.snowplowSessionId,
      cpOwnerShopID: evGTMConversionData?.cpOwnerShopId,
    };

    campaign = { ...campaign, ...window.evGTMTracking.getUtmParams?.() };
  }

  return {
    conversionData,
    campaign,
  };
};

export const replaceURLParams = (url: string | URL, data: Record<string, string>, preservedParams: string[] = []): string => {
  const urlObject = new URL(url.toString());
  const preservedEntries: Record<string, string> = {};
  for (const key of preservedParams) {
    const value = urlObject.searchParams.get(key);
    if (value) {
      preservedEntries[key] = value;
    }
  }

  urlObject.search = '';

  for (const [key, value] of Object.entries(preservedEntries)) {
    urlObject.searchParams.set(key, value);
  }

  const filteredData = Object.entries(data).filter(([, value]) => value);

  for (const [key, value] of filteredData) {
    urlObject.searchParams.set(key, value);
  }

  return urlObject.toString();
};
